import styles from './dictation.module.css'
import React, { useLayoutEffect, useRef } from 'react'
import { Capsule } from 'components/ui'
import { useChatDictation } from './useChatDictation'
import { MicrophoneWaveform } from '../MicrophoneWaveform'
import useLocaleText from 'components/useLocaleText'
import { dictationLiterals } from './literals'

export const ChatDictation = ({ speech, seconds, original }: ReturnType<typeof useChatDictation>) => {
  const t = useLocaleText(dictationLiterals)

  const transcript = useRef<HTMLDivElement>(null)
  const following = useRef(true)

  useLayoutEffect(() => {
    if (!speech.listening) {
      following.current = true
      return
    }

    const node = transcript.current
    if (node && following.current) node.scrollTop = Math.max(0, node.scrollHeight - node.clientHeight)
  }, [speech.listening, speech.finalTranscript, speech.interimTranscript, original])

  return (
    <>
      {speech.listening && (
        <div className={styles.recording}>
          <Capsule label={speech.isStarting ? t.starting : t.recording} color="#3F7A55" dot />
          <span className={styles.timer}>
            {Math.floor(seconds / 60)}:{String(seconds % 60).padStart(2, '0')}
          </span>
          <MicrophoneWaveform active={speech.listening && !speech.isStarting} />
          <span className={styles.cancelHint}>{t.cancelHint}</span>
        </div>
      )}
      {speech.listening && (
        <div
          ref={transcript}
          className={styles.dictationText}
          aria-live="polite"
          onScroll={(event) => {
            const node = event.currentTarget
            following.current = node.scrollHeight - node.clientHeight - node.scrollTop <= 32
          }}
        >
          {original}
          {original && ' '}
          {speech.finalTranscript}
          <span className={styles.interim}>
            {speech.finalTranscript && ' '}
            {speech.interimTranscript}
          </span>
        </div>
      )}
    </>
  )
}
